import { render, staticRenderFns } from "./paginationComponent.vue?vue&type=template&id=dc7886de"
import script from "./paginationComponent.vue?vue&type=script&lang=js"
export * from "./paginationComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiIconsPostArrow: require('/home/node/app/components/ui/icons/postArrow.vue').default})
